<template>
    <div class="activity-indicator-circle-fade">
        <div class="activity-indicator-circle1 activity-indicator-circle" />
        <div class="activity-indicator-circle2 activity-indicator-circle" />
        <div class="activity-indicator-circle3 activity-indicator-circle" />
        <div class="activity-indicator-circle4 activity-indicator-circle" />
        <div class="activity-indicator-circle5 activity-indicator-circle" />
        <div class="activity-indicator-circle6 activity-indicator-circle" />
        <div class="activity-indicator-circle7 activity-indicator-circle" />
        <div class="activity-indicator-circle8 activity-indicator-circle" />
        <div class="activity-indicator-circle9 activity-indicator-circle" />
        <div class="activity-indicator-circle10 activity-indicator-circle" />
        <div class="activity-indicator-circle11 activity-indicator-circle" />
        <div class="activity-indicator-circle12 activity-indicator-circle" />
    </div>
</template>